import { render, staticRenderFns } from "./Error500.vue?vue&type=template&id=3f2f815e&scoped=true&"
import script from "./Error500.vue?vue&type=script&lang=js&"
export * from "./Error500.vue?vue&type=script&lang=js&"
import style0 from "./Error.scss?vue&type=style&index=0&id=3f2f815e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2f815e",
  null
  
)

export default component.exports